module.exports = __webpack_public_path__ + "static/media/home.00d7a477.svg";